import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { WarningAmber } from "@mui/icons-material";

const ConfirmDialog = ({
  open,
  title = "Are you sure?",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "error",
  loading = false,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle
      sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1 }}
    >
      <WarningAmber color={confirmColor} />
      <Typography fontWeight={700}>{title}</Typography>
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5 }}>
      <Button
        onClick={onCancel}
        variant="outlined"
        size="small"
        disabled={loading}
      >
        {cancelLabel}
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        color={confirmColor}
        size="small"
        disabled={loading}
      >
        {loading ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          confirmLabel
        )}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
